<template>
  <vx-card no-shadow>
    <h2>Preview of report</h2>
    <div class="mb-6">{{ moment(report.date).format("LL") }}</div>

    <div id="mail-template">
      <h3>
        Daily End of day Report for
        {{ moment(report.date).format("DD-MM-YYYY") }}
      </h3>
      <span>Closed at {{ report.closingTime }} and last guest was out {{ report.lastGuestOutTime }}</span>

      <div style="margin: 16px 0px 16px 8px" v-for="data in mailData" :key="data.title">
        <b>{{ data.title }}</b>
        <div :style="{ fontStyle: data.isEmpty ? 'italic' : 'normal' }" v-html="data.value"></div>
      </div>

      <div style="margin: 16px 0px 16px 8px">
        <b>Facade</b>
        <img v-if="report.imageUrls.length > 0" :src="report.imageUrls[0]" />
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-center mt-4">
      <vs-button @click="sendMail" id="send-mail-button" class="ml-auto mt-2">Send Mail</vs-button>
    </div>
  </vx-card>
</template>

<script>
import Vue from "vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

// import ReportImages from "./ReportImages.vue";
const ReportImages = () => import("./ReportImages.vue");

export default {
  components: {
    flatPickr,
    ReportImages
  },
  props: {
    report: Object
  },
  data() {
    return {
      moment,
      startDate: null,
      closingDate: null,
      lastGuestDate: null,
      configDate: {
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "M j, Y",
        defaultHour: 18,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      },
      configClosingDate: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i",
        defaultHour: 4,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      },
      configLastGuestDate: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        dateFormat: "H:i",
        defaultHour: 4,
        defaultMinute: 0,
        defaultSecond: 0,
        onChange: function (selectedDates) {}
      }
    };
  },
  computed: {
    musicScoreText() {
      switch (this.report.musicRating) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Awesome";
        default:
          return "Not rated";
      }
    },
    safetyScoreText() {
      switch (this.report.safetyRating) {
        case 1:
          return "Awful";
        case 2:
          return "Not good";
        case 3:
          return "Alright";
        case 4:
          return "Good";
        case 5:
          return "Perfect";
        default:
          return "Not rated";
      }
    },
    defectsPriorityText() {
      switch (this.report.defectsPriority) {
        case 0:
          return "None";
        case 1:
          return "Low";
        case 2:
          return "Medium";
        case 3:
          return "High";
        default:
          return "None";
      }
    },
    defectsPriorityColor() {
      switch (this.report.defectsPriority) {
        case 0:
          return "grey";
        case 1:
          return "#28C76F";
        case 2:
          return "#FF9F43";
        case 3:
          return "#EA5455";
        default:
          return "grey";
      }
    },
    mailData() {
      return [
        this.extractValue("Arrangements", this.report.arrangement, "No arrangements"),
        this.extractValue("General comments", this.report.generalComments, "No comments"),
        this.extractValue("Personale comments", this.report.personaleComments, "No comments"),
        this.extractValue("Marketing/Guest relations", this.report.guestRelationsComments, "No comments"),
        this.extractValue("Gimmicks/focus", this.report.focusComments, "No comments"),
        this.extractValue(
          "Defects/needs",
          `${this.report.defectsAndNeedsComments} <br /> Priority: <b>${this.defectsPriorityText}</b>`,
          "No defects or needs"
        ),
        this.extractValue("Music", `Rated: <b>${this.musicScoreText}</b> ( ${this.report.musicRating}/5 )`, "Not rated"),
        this.extractValue("Safety/Clientele", `Rated: <b>${this.safetyScoreText}</b> ( ${this.report.safetyRating}/5 )`, "Not rated")
        // TODO photos
      ];
    }
  },
  methods: {
    extractValue(title, value, emptyText) {
      return value === "" ? { title, value: emptyText, isEmpty: true } : { title, value, isEmpty: false };
    },
    sendMail() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#send-mail-button",
        scale: 0.45
      });

      this.$store
        .dispatch("eodReports/sendEodReport", this.report.id)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Report sent"
          });
        })
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Report could not be sent: " + err
          });
        })
        .finally(() => {
          this.$vs.loading.close("#send-mail-button > .con-vs-loading");
        });
    }
  },
  async created() {
    this.$vs.loading();
    await this.$store.dispatch("eodReports/getEodReport", this.report.id);
    this.$vs.loading.close();
  }
};
</script>

<style style="scss" scoped>
#mail-template {
  margin: 0px 16px;
  padding: 12px;
  border: 1px solid #ccc;
}
</style>
